var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35023 2.35C3.80023 0.9 5.79023 0 8.00023 0C12.4202 0 15.9902 3.58 15.9902 8C15.9902 12.42 12.4202 16 8.00023 16C4.27024 16 1.16024 13.45 0.270235 10H2.35023C3.17023 12.33 5.39023 14 8.00023 14C11.3102 14 14.0002 11.31 14.0002 8C14.0002 4.69 11.3102 2 8.00023 2C6.34023 2 4.86024 2.69 3.78024 3.78L7.00023 7H0.000234604V0L2.35023 2.35Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.5d19d359.svg";
export { ForwardRef as ReactComponent };